import * as types from '../mutation-types'
import bulkPricesRepository from '../../api/bulkPricesRepository'

const state = {
    productBulkPricesToCreate: [],
    areProductBulkPricesCreated: false,
    productBulkPrices: []
}

const getters = {
    productBulkPricesToCreate: state => state.productBulkPricesToCreate,
    areProductBulkPricesCreated: state => state.areProductBulkPricesCreated,
    productBulkPrices: state => state.productBulkPrices
}

const actions = {
    createUpdateProductBulkPrices({ commit }) {
        return bulkPricesRepository.createUpdateProductBulkPrices(state.productBulkPricesToCreate).then((response) => {
            if (response.data.success) {
                commit(types.SET_PRODUCT_BULK_PRICES_CREATED, true)
            } else {
                commit(types.SET_PRODUCT_BULK_PRICES_CREATED, false)
            }
        })
    },
    getBulkPricesForProduct({ commit }, productId) {
        return bulkPricesRepository.getBulkPricesForProduct(productId).then((response) => {
            commit(types.SET_PRODUCT_BULK_PRICES, response.data)
        })
    },
}

const mutations = {
    [types.SET_PRODUCT_BULK_PRICES](state, payload) {
        state.productBulkPrices = payload
    },
    [types.ADD_PRICE_TO_PRODUCT_BULK_PRICES](state, payload) {
        state.productBulkPrices.push(payload)
    },
    [types.REMOVE_PRICE_FROM_PRODUCT_BULK_PRICES](state, payload) {
        state.productBulkPrices.splice(payload.index, 1)
    },
    [types.SET_PRODUCT_BULK_PRICES_TO_CREATE](state, payload) {
        state.productBulkPricesToCreate = payload
    },
    [types.SET_PRODUCT_BULK_PRICES_CREATED](state, payload) {
        state.areProductBulkPricesCreated = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
